const editedRowBlinkClassName = 'recently__edited__row__blink'

export const scrollAndBlinkEditedRow = (row: HTMLDivElement | null) => {
    if (!row) return undefined

    row.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
    row.classList.remove(editedRowBlinkClassName)
    void row.offsetWidth
    row.classList.add(editedRowBlinkClassName)

    const timer = window.setTimeout(() => {
        row.classList.remove(editedRowBlinkClassName)
    }, 1800)

    return () => {
        window.clearTimeout(timer)
        row.classList.remove(editedRowBlinkClassName)
    }
}
